import icon from "../../assets/door.svg";
import type { Property } from "../../types";

export const inputTerminals: Property = {
  id: "inputTerminals",
  title: "inputTerminals.title",
  icon,
};
